var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMessageView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1256_42179)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1256_42179",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 0H0V64H64V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1256_42179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 48H42V52H22V48Z",
    fill: "#64B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 56H38V60H26V56Z",
    fill: "#64B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6202 36.282C18.8522 33.726 15.9922 31.044 15.9922 24C15.9922 15.178 23.1682 8 31.9922 8V4C20.9622 4 11.9922 12.972 11.9922 24C11.9922 32.802 15.9902 36.536 18.9102 39.234C20.9342 41.102 21.9922 42.164 21.9922 44H25.9922C25.9922 40.322 23.7702 38.268 21.6202 36.282Z",
    fill: "#64B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3599 36.286C40.2179 38.27 38.0039 40.324 38.0039 44H42.0039C42.0039 42.162 43.0579 41.1 45.0739 39.23C47.9839 36.534 52.0039 32.8 52.0039 24H48.0039C48.0039 31.048 45.1179 33.728 42.3599 36.286Z",
    fill: "#64B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 15C40 16.656 38.656 18 37 18C35.344 18 34 16.656 34 15C34 13.344 35.344 12 37 12C38.656 12 40 13.344 40 15Z",
    fill: "#64B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 15C60 16.656 58.656 18 57 18C55.344 18 54 16.656 54 15C54 13.344 55.344 12 57 12C58.656 12 60 13.344 60 15Z",
    fill: "#64B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 11C50 12.656 48.656 14 47 14C45.344 14 44 12.656 44 11C44 9.344 45.344 8 47 8C48.656 8 50 9.344 50 11Z",
    fill: "#64B6AC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1256_42179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessageView);
export default __webpack_public_path__ + "static/media/no-message-view.f955749ab8770e5f41b02d0b8a6b16c8.svg";
export { ForwardRef as ReactComponent };